

































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import LanguagesBtns from "@/components/app/shared/btn&dd/languages-btns.vue";
import BSwitch from "@/components/app/shared/switchs/b-switch.vue";
import ConsentsPosterUpload from "./consents-poster-upload.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import type { IConsents } from "@/@types/filoxenia-config/consents";
import type { ILocale } from "@/@types/locale";
import type { LanguageCode } from "@/@types/_shared/locale";

@Component({
  components: {
    StandartModal,
    LanguagesBtns,
    BSwitch,
    ConsentsPosterUpload,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
    code: { required },
  },
})
class ConsentsEditModal extends Vue {
  @Prop({ type: Object, default: null }) item!: IConsents | null;

  defaultLocale: LanguageCode = this.$store.getters.getLanguages
    ? this.$store.getters.getLanguages[0]
    : "ru";
  currentLocale: LanguageCode = this.defaultLocale;

  show = true;
  consents_require = false;
  name = "";
  names: ILocale = {};
  code = "";
  poster: ILocale = {};

  @Watch("currentLocale")
  changeLocale(): void {
    this.name = this.names[this.currentLocale] || "";
  }

  @Watch("name")
  changeName(): void {
    this.$set(this.names, this.currentLocale, this.name);
  }

  @Watch("item")
  autoFillingForm(): void {
    if (!this.item) return;
    this.names = { ...this.item.name };
    this.code = this.item.code || "";
    this.show = this.item.show;
    this.consents_require = this.item.consents_require;
    this.poster = this.item.src ? { ...this.item.src.poster } : {};
    this.changeLocale();
  }

  onSubmit(e: Event): void {
    e.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }

    const data: Partial<IConsents> = {
      name: this.names,
      code: this.code,
      show: this.show,
      consents_require: this.consents_require,
      src: {
        poster: this.poster,
      },
    };

    this.$emit("save", data);
    this.$bvModal.hide("consents-config-edit");
  }

  isClean(): void {
    this.names = {};
    this.name = "";
    this.code = "";
    this.show = true;
    this.consents_require = false;
    this.poster = {};
    this.currentLocale = this.defaultLocale;
    this.$v.$reset();
  }
}
export default ConsentsEditModal;
